import axios from 'axios';
import { SellerContactFormRequest } from '../../structures/requests/sellerContactForm';
import { SellerContactFormInterface } from '../../structures/models/sellerContactForm';
import routes from '../routes';
import { SellerDetailsContactType } from '../../structures/models/seller';
import { createEmailVerification } from '../../structures/requests/user';

export const createSellerContactForm = async (
  request: SellerContactFormRequest,
): Promise<SellerContactFormInterface> => {
  const response = await axios
    .post(
      routes.API_SELLER_CONTACT_POST,
      request,
      { headers: { Accept: 'application/json' } },
    );
  return response.data.data;
};

export const getSellerContactFormData = async (
  sellerContactId: number,
  listingId?: number|null|undefined,
  listingType?: string|null|undefined,
): Promise<SellerDetailsContactType> => {
  const response = await axios
    .get(
      routes.API_SELLER_CONTACT_FORM_INFO(sellerContactId, listingId, listingType),
      { headers: { Accept: 'application/json' } },
    );
  return response.data.data;
};

export const resendEmailVerificationLink = async (): Promise<any> => {
  await createEmailVerification()
    .then((response) => {
      return response.data.message;
    })
    .catch((error) => {
      throw error;
    });
};
